export const INTERNAL_ANALYTICS_STORAGE_KEY = 'servd_posthog_internal_frank'
export const INTERNAL_ANALYTICS_DISTINCT_ID = 'servd-internal-frank'
const INTERNAL_ANALYTICS_ACTIVATION_HASH = '#servd-internal=741b928ea1c1309f165c147bee34aa45'

export function activateInternalAnalyticsBrowserFromLink(): void {
  if (window.location.hash !== INTERNAL_ANALYTICS_ACTIVATION_HASH) return

  try {
    window.history.replaceState(window.history.state, '', window.location.pathname + window.location.search)
  } catch {
    // Een geblokkeerde History API mag analytics-initialisatie niet stoppen.
  }
  try {
    window.localStorage.setItem(INTERNAL_ANALYTICS_STORAGE_KEY, '1')
  } catch {
    // Tracking blijft uit wanneer de browser lokale opslag blokkeert.
  }
}

export function isInternalAnalyticsBrowser(): boolean {
  try {
    return window.localStorage.getItem(INTERNAL_ANALYTICS_STORAGE_KEY) === '1'
  } catch {
    return false
  }
}
